import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useEffect, useMemo, useRef } from 'react';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { createSwiperInstance } from "./utils";
export var useSwiperInstance = function useSwiperInstance(_ref) {
  var loop = _ref.loop,
    onSwiperInit = _ref.onSwiperInit,
    withControls = _ref.withControls,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'default' : _ref$mode,
    swiperOptions = _ref.swiperOptions,
    autoPlay = _ref.autoPlay;
  var swiper = useRef();
  var nextControlRef = useRef(null);
  var prevControlRef = useRef(null);
  var swiperNodeRef = useRef(null);
  var isMobile = useIsMobileDimension();
  useEffect(function () {
    if (swiper.current) {
      var _swiper$current;
      (_swiper$current = swiper.current) === null || _swiper$current === void 0 ? void 0 : _swiper$current.destroy();
    }
    if (swiperNodeRef.current) {
      swiper.current = createSwiperInstance(swiperNodeRef.current, mode, _objectSpread(_objectSpread({}, swiperOptions || {}), {}, {
        isMobile: isMobile,
        loop: loop,
        withControls: withControls,
        nextControlRef: nextControlRef,
        prevControlRef: prevControlRef
      }));
      onSwiperInit === null || onSwiperInit === void 0 ? void 0 : onSwiperInit(swiper.current);
    }
    return function () {
      var _swiper$current2;
      (_swiper$current2 = swiper.current) === null || _swiper$current2 === void 0 ? void 0 : _swiper$current2.destroy();
    };
  }, [loop, autoPlay, swiperOptions, isMobile]);
  return useMemo(function () {
    return {
      swiper: swiper,
      swiperNodeRef: swiperNodeRef,
      prevControlRef: prevControlRef,
      nextControlRef: nextControlRef
    };
  }, []);
};